<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Inventory Orders" />
      <h2>Inventory Orders</h2>
      <BreadCrumbs activeItem="Inventory Orders" :crumbs="{ home: 'Dashboard' }"/>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <div class="mb-3">
        <jet-button icon="fas fa-box" class="mr-2" :goesTo="route('inventory.order')">Create Order</jet-button>
        <jet-button icon="fas fa-box" class="mr-2" :goesTo="route('inventory.shipments')">Shipments</jet-button>
        <jet-button icon="fas fa-box" :goesTo="route('inventory.fromproducts')">Products</jet-button>
      </div>

      <div class="col-12 col-xl-6 px-0 mb-3">
        <card title="Find By" headerStyle="primary">
          <div class="row">
            <div class="col-12 col-lg-6">
              <p class="m-0">PO # / Invoice #</p>
              <Search :searchText="searchText" @searched="search"/>
            </div>
            <div class="col-12 col-lg-6">
              <p class="m-0">Product</p>
              <Search @searched="searchProduct"/>
            </div>
          </div>
        </card>
      </div>

      <SelectButton v-model="searchStatus" :options="status" optionLabel="desc" optionValue="id" :multiple="true" @click="statusFilter">
      <template #option="slotProps">
        <div class="status-option">
          <div>{{slotProps.option.desc}}
            <span class="status-option-count">{{slotProps.option.count}}</span>
          </div>
        </div>
      </template>
      </SelectButton>
  
      <DataTable 
        ref="admin-inventory-table" 
        :value="inventory" :paginator="true" :rows="20" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" removableSort currentPageReportTemplate="({first} - {last} of {totalRecords})"
        paginatorPosition="both" breakpoint="992px"
        :rowClass="() => {return 'table-row'}"
        :rowsPerPageOptions="[10, 20, 50, 100]" 
        sortField="date" :sortOrder="-1"
        stateStorage="local" stateKey="admin-inventory-orders" dataKey="id"
        class="p-datatable-sm admin-datatable"
        tableClass="border-left border-right border-bottom"
        @row-click="(e) => $inertia.get(route('inventory.view', e.data.id))">
          <template #paginatorLeft>
            {{ inventory.length }} Inventory Orders
          </template>
          <Column field="id" header="ID" :sortable="true"></Column>
          <Column field="order_number" header="Order #" :sortable="true"></Column>
          <Column field="status_desc" header="Status" :sortable="true"></Column>
          <Column field="manufacturer" header="Manufacturer" :sortable="true"></Column>
          <Column field="user" header="User" :sortable="true"></Column>
          <Column field="date" header="Date" :sortable="true">
            <template #body="slotProps">
              {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
            </template>
          </Column>

          <Column class="button-container" :exportable="false">
            <template #body="slotProps">
              <jet-button class="btn-short text-nowrap" :goesTo="route('inventory.view', slotProps.data.id)" icon="fas fa-chevron-right">View</jet-button>
            </template>
          </Column>
      </DataTable>
    </template>
  </layout>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Admin/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchFilter from '@/Shared/SearchFilter'
  import FlashMessages from '@/Shared/FlashMessages'
  import moment from 'moment'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  import Search from '@/Shared/Admin/Search'
  import Multiselect from '@vueform/multiselect'

  import SelectButton from 'primevue/selectbutton'

  export default {
    components: {
      Icon,
      SearchFilter,
      Layout,
      Multiselect,
      SelectButton,
      FlashMessages,
      BreadCrumbs,
      Search
    },
    props: {
      inventory: Array,
      query: String,
      manufacturers: Array,
      categories: Array,
      status: Array,
      selectedStatus: Array
    },
    data() {
      return {
        searchText: this.query,
        searchStatus: this.selectedStatus,
        categories_selected: [],
        manufacturers_selected: []
      }
    },
    created() {
      this.moment = moment;
    },
    methods: {
      search(e, searchText) {
        this.$refs['admin-inventory-table'].d_sortField = null
        this.$refs['admin-inventory-table'].resetPage()
        this.$inertia.get(this.route('inventory'), {
          query: searchText,
          status: this.searchStatus
        })
      },
      searchProduct(e, searchText) {
        this.$inertia.get(this.route('inventory.shipments'), {
          query: searchText,
          status: this.searchStatus
        })
      },
      category(selected) {
        // control gets this event before model is updated
        this.categories_selected = selected;
        this.search();
      },
      manufacturer(selected) {
        this.manufacturers_selected = selected;

        this.search();
      },
      statusFilter(e) {
        this.$refs['admin-inventory-table'].resetPage()
        this.$inertia.get(this.route('inventory'), {
          query: this.searchText,
          status: this.searchStatus.length > 0 ? this.searchStatus : [-2]
        })
      },
    },
  }
</script>

<style src="@vueform/multiselect/themes/default.css"></style>